import styled from "styled-components";

export const MapContainer = styled.div`
  width: 100%;
  height: 500px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
`;

export const MapDrawWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const DrawingOverlay = styled.div`
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
  /* Deixar os cliques passarem para o mapa; só o botão captura cliques */
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  max-width: 92%;
  padding: 10px 16px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.72);
  color: #fff;
  text-align: center;
  font-family: "Asap", sans-serif;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);

  strong {
    font-size: 14px;
    font-weight: 600;
  }

  span {
    font-size: 12px;
    line-height: 1.3;
  }

  .meta {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 6px;
  }

  .meta span {
    font-weight: 600;
  }

  button {
    pointer-events: auto;
    border: none;
    border-radius: 6px;
    padding: 4px 12px;
    font-size: 12px;
    font-weight: 600;
    font-family: "Asap", sans-serif;
    color: #fff;
    background: #684e96;
    cursor: pointer;

    &:disabled {
      background: rgba(255, 255, 255, 0.25);
      cursor: not-allowed;
    }
  }
`;

export const FormCard = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow-y: auto;

  label {
    display: block;
    font-family: "Asap", sans-serif;
    font-size: 14px;
    margin-bottom: 4px;
    font-weight: 500;
    color: #9074bf;

    &.error {
      color: #d44c4c;
    }
  }
`;

export const MapCenterContainer = styled.div`

  label {
    display: block;
    font-family: "Asap", sans-serif;
    font-size: 14px;
    margin-bottom: 4px;
    font-weight: 500;
    color: #9074bf !important;

    &.error {
      color: #d44c4c;
    }
  }
`;

export const AnimalInfoContainer = styled.div`
  padding: 16px 0;
`;

export const StockingRateContainer = styled.div`
  margin-bottom: 16px;

  strong {
    font-weight: 600;
    color: #333;
  }
`;

export const ActiveAnimalsContainer = styled.div`
  text-align: center;
  margin-bottom: 16px;
`;

export const TotalAnimalsNumber = styled.span`
  font-size: 24px;
  font-weight: bold;
  display: block;
  color: #333;
`;

export const TotalAnimalsLabel = styled.span`
  font-size: 12px;
  text-transform: uppercase;
  color: #666;
`;

export const DataContainer = styled.div`
  .col {
    display: flex;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .cell {
    flex: 1;
    text-align: center;

    &:first-child {
      text-align: left;
    }
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  strong {
    margin-left: 4px;
    font-weight: 600;
    color: #333;
  }
`;

export const LabelCell = styled.div`
  flex: 1;
  text-align: left;

  label {
    font-size: 12px;
    color: #666;
    font-weight: 500;
  }
`;

export const ValueCell = styled.div`
  flex: 1;
  text-align: center;

  span {
    font-size: 12px;
    color: #333;

    strong {
      font-weight: 600;
    }
  }
`;
